/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Link } from "react-router-dom";
import Globals from "../shared/Globals";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Icon from "./Icon";
import { v4 as uuidv4 } from 'uuid';
import sanitizeHtml from 'sanitize-html';

export default class FormLabel extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            id: uuidv4()
        };
    }

    componentDidMount() {
        this.setState({ value: this.props.model });
        this.formatProps(this.props);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.model !== this.props.model) {
            this.setState({ value: this.props.model });
            this.formatProps(this.props);
        }
    }

    formatProps = (props) => {
        if (typeof (props.model) === 'object') {
            if (props.model instanceof Date) {
                this.setState({ value: Globals.toMDYDateString(props.model) });
            }
        }
        else if (typeof (props.model) === 'string') {
            var regex = /\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d/g;
            if (regex.test(props.model)) {
                this.setState({ value: Globals.toMDYDateString(new Date(props.model)) });
            }
        }
    }

    nl2br(str) {
        if (str && str.replace)
            return this.sanitize(str.replace(/\n/g, '<br />'));
        return str;
    }

    sanitize(html) {
        const allowed = {
            allowedTags: ['br']
        };
        return sanitizeHtml(html, allowed);
    }

    render() {
        let t = { tag: 'div' }

        if (this.props.onClick)
            t.tag = 'a';
        return <div className="c-formlabel mb-3">
            <h5>{this.props.label}</h5>
            {this.props.textarea ? <div className="c-value" dangerouslySetInnerHTML={{ __html: this.nl2br(this.props.model) }}></div> :
                <t.tag className={'d-block c-value' + (this.props.valueClassName ? ' ' + this.props.valueClassName : '')} onClick={this.props.onClick} role={this.props.onClick ? 'button' : null}>
                    {this.props.link ? <Link to={this.props.link}>{this.props.model ?? '(none)'}</Link> : (this.props.model ?? '(none)')} {this.props.postFix}
                    {this.props.onEdit && <button type="button" className="btn btn-primary btn-sm float-end" onClick={this.props.onEdit}>
                        <Icon icon="faEdit" />
                    </button>}
                </t.tag>}

        </div>;
    }
}
